<template>
  <div class="content">
    <div
      v-if="page==='list'"
      class="indexList"
    >
      <el-row :gutter="20">
        <el-col :span="18">
          <el-card class="box-card">
            <div
              slot="header"
              class="clearfix"
            >
              <div class="h_left">hi,{{userList.nick_name}}</div>
              <div class="h_right">上次登录信息(仅供参考) IP:{{userList.login_ip}} 登录时间: {{userList.prev_time}}</div>
            </div>
            <div class="item">
              <div style=" display: flex;">
                <div class="item_left">
                  <div class="item_title">您的账户余额</div>
                  <div class="item_balance">¥{{userList.money}}</div>
                  <div>
                    <el-button
                      style="margin-right: 15px;"
                      @click="Viewdetails()"
                    >查看明细</el-button>
                    <el-button
                      type="danger"
                      @click="ViewRecharge()"
                    >去充值</el-button>
                  </div>
                </div>
                <div class="line"></div>
              </div>
              <div class="item_right">
                <div class="i_r_code">
                  <img
                    :src="customerList.pic"
                    alt=""
                  >
                  <p>客户经理微信</p>
                </div>
                <div class="i_r_text">
                  <p class="p_title">{{customerList.name}}</p>
                  <p class="p_phone">联系电话：{{customerList.tel}}</p>
                  <p class="p_wchat">微信号：{{customerList.wechat}}</p>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <div class="banner">
            <el-carousel height="240px">
              <el-carousel-item
                v-for="item in 4"
                :key="item"
              >
                <img
                  src="@/assets/imgs/img_index_banner.png"
                  alt=""
                  srcset=""
                >
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="18">
          <el-card class="bottom_card">
            <div
              slot="header"
              class="clearfix"
            >
              <div class="h_left">
                <span class="h_black">实时数据</span>
                <span class="h_gray">更新于 {{updateTime}}
                  <el-tooltip
                    effect="dark"
                    content="每2小时更新1次"
                    placement="right"
                  >
                    <i
                      style=" margin-left: 10px;cursor: pointer;"
                      class="el-icon-warning-outline"
                    ></i>
                  </el-tooltip>
                </span>
              </div>
              <div class="h_right">
                <div class="block">
                  <span class="demonstration"></span>
                  <el-date-picker
                    v-model="beanData"
                    type="daterange"
                    format="yyyy-MM-dd"
                    @change="changeTime"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>

                </div>
              </div>
            </div>
            <div class="echartsTop">
              <div class="echartTitle">
                <div><span class="sucsses"></span>成功率</div>
                <div><span class="fail"></span>失败率</div>
              </div>
              <div class="echartsRight">
                <div
                  class="icon"
                  @click="tabEcharts()"
                >
                  <img
                    v-if="isEcharts"
                    src="@/assets/imgs/icon_line_def.svg"
                    alt=""
                  >
                  <img
                    v-if="!isEcharts"
                    src="@/assets/imgs/icon_histogram_def.svg"
                    alt=""
                  >
                </div>
              </div>
            </div>
            <div v-if="isEcharts==true">
              <div
                ref="myRef"
                style="height: 400px;"
              >
              </div>
            </div>
            <div v-if="isEcharts==false">
              <div
                ref="myEcharts"
                style="height: 400px;"
              >
              </div>
            </div>

          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="b_right_card">
            <div
              slot="header"
              class="clearfix"
            >
              最新公告
            </div>
            <div class="Notice">
              <div
                class="Noticeli"
                v-for="(item,index) in noticeList "
                :key="index"
              >
                <p
                  style=" margin-bottom: 10px;cursor: pointer;"
                  @click="jumpNotice(item)"
                >
                  <span class="time"> {{ interceptTime(item.add_time) }}</span>
                  <span :class="item.type==1 ? 'red':''">
                    {{item.title }} <span
                      v-if="item.type==1"
                      class="bi"
                    >热门</span></span>
                </p>

              </div>
            </div>
          </el-card>
          <el-card class="b_right_card">
            <div
              slot="header"
              class="clearfix"
            >
              最新接口
            </div>
            <div class="Notice">
              <div
                class="Noticeli"
                v-for="(item,index) in openApi "
                :key="index"
              >
                <p
                  style=" margin-bottom: 10px;cursor: pointer;"
                  @click="jumpApi(item)"
                >
                  <span class="time"> {{interceptTime(item.add_time) }}</span>
                  <span :class="item.type==1 ? 'red':''">
                    {{item.title }} <span
                      v-if="item.type==1"
                      class="bi"
                    >热门</span></span>
                </p>

              </div>
            </div>
          </el-card>
        </el-col>

      </el-row>

    </div>

    <recharge
      v-if="page==='recharge'"
      @watchPage="getchildmsg(arguments)"
    >
      <BreadcrumbBack
        class="bread"
        :navs="recharge"
      />
    </recharge>
    <div v-if="page==='payment'">

      <payment
        :payorder="payorder"
        @watch="getPaymentMsg(arguments)"
      >
        <BreadcrumbBack
          class="bread"
          :navs="paymentNavs"
        />
      </payment>

    </div>

  </div>

</template>
<script>
import * as echarts from 'echarts';
import BreadcrumbBack from '@/tools/BreadcrumbBack'
import Recharge from './Recharge.vue';
import apis from "@/api/apis";
import Payment from '../MyInterface/Payment.vue';

export default {
  components: { BreadcrumbBack, Recharge, Payment, },
  name: 'ConsoleHome',

  data () {
    return {
      beanData: [new Date() - 7 * 24 * 3600 * 1000, new Date() - 1 * 24 * 3600 * 1000],
      value2: '',
      page: 'list',//切换组件
      userList: {},//用户信息
      customerList: [],//客服信息
      noticeList: [],//公告列表
      openApi: [],
      xData: [],//x轴值
      SuccessData: [],//成功值
      failData: [],//失败值
      payorder: [],
      updateTime: '',
      isEcharts: true


    };
  },
  mounted () {
    console.log("shouye");
    if (this.$route.params.page) {
      this.page = this.$route.params.page
    }
    this.getUserInfo()
  },
  computed: {
    navs () {
      return [
        {
          title: '首页',
          onClick: () => { this.page = 'list' }
        },
        {
          title: '费用明细'
        }
      ]
    },
    recharge () {
      return [
        {
          title: '首页',
          onClick: () => { this.page = 'list' }
        },
        {
          title: '充值'
        }
      ]
    },
    paymentNavs () {
      return [
        {
          title: '首页',
          onClick: () => { this.page = 'list' }
        },
        {
          title: '充值',
          onClick: () => { this.page = 'recharge' }
        },
        {
          title: '支付'
        }
      ]
    },
  },

  updated () {
    if (this.$refs.myRef) {
      this.initEcharts()
    }
    /*  if (this.$refs.myEcharts) {
       this.getEcharts()
     } */
    if (localStorage.getItem('pageId')) {
      //从缓存中读取参数
      this.page = localStorage.getItem('pageId') || "";
      //读取参数后，删除
      localStorage.removeItem('pageId');
    }

  },
  methods: {
    //跳转公告
    jumpNotice (item) {
      window.open('https://open.wikeyun.cn/#/notice/' + item.type + '/detail/' + item.id)

    },
    //跳转接口
    jumpApi (item) {
      window.open('https://open.wikeyun.cn/#/apiDocument/' + item.cate_id + '/document/' + item.id)

    },
    getchildmsg (res) {
      console.log(res[1], "123");
      this.page = res[0]
      this.payorder = res[1]
    },
    //时间范围限制
    changeTime (data) {
      this.choiceDate = ''
      let oDate1 = data[0]
      let oDate2 = data[1]
      let nowDate = new Date();
      if (oDate1 && oDate2) {
        if (oDate1.getTime() > oDate2.getTime() - 1) {//开始时间不能大于等于结束时间
          this.$message({
            message: '开始时间不能大于等于结束时间',
            type: 'warning'
          })
          return;
        }

        if (oDate1.getTime() >= nowDate.getTime()) {//开始时间不能大于等于当前时间前一天
          this.$message({
            message: '开始时间不能大于等于当前时间前一天',
            type: 'warning'
          })
          return;
        }
        if (oDate2.getTime() - oDate1.getTime() < 6 * 24 * 3600 * 1000) {//至少选择七天
          this.$message({
            message: '至少选择七天',
            type: 'warning'
          })
          //如果加俩天天大于当前时间就选择前俩天
          if (new Date(oDate1.getTime() + 6 * 24 * 3600 * 1000) > nowDate.getTime()) {

            this.beanData[0] = new Date(oDate1.getTime() - 6 * 24 * 3600 * 1000);

          } else {

            this.beanData[1] = new Date(oDate1.getTime() + 6 * 24 * 3600 * 1000);
          }
          this.getSuccessRate()
          return this.beanData[1]
        }
        if (oDate2.getTime() - oDate1.getTime() > 30 * 24 * 3600 * 1000) {//最多选择一个月
          this.$message({
            message: '最多选择一个月',
            type: 'warning'
          })
          //如果加六天大于当前时间就选择前六天
          if (new Date(oDate1.getTime() + 30 * 24 * 3600 * 1000) > nowDate.getTime()) {
            this.beanData[0] = new Date(oDate1.getTime() - 29 * 24 * 3600 * 1000);
          } else {
            this.beanData[1] = new Date(oDate1.getTime() + 30 * 24 * 3600 * 1000);
          }
          this.getSuccessRate()
          return this.beanData[1]
        }
        this.getSuccessRate()
      }

    },
    //时间格式
    getDateTime (startTime) {
      let yy = new Date(startTime).getFullYear();
      let mm = new Date(startTime).getMonth() + 1;
      let dd = new Date(startTime).getDate();
      return yy + '-' + mm + '-' + dd
    },
    //成功率
    getSuccessRate () {
      let startTime = this.beanData[0]
      let endTime = this.beanData[1]
      apis.index.SuccessRate({
        start_time: this.getDateTime(startTime),
        end_time: this.getDateTime(endTime),
      }).then(res => {
        this.xData = []
        this.SuccessData = []
        this.failData = []
        this.updateTime = res.data.update_time
        var list = res.data.data
        for (var k in list) {
          this.xData.push(k)
          this.SuccessData.push(list[k].successCount)
          this.failData.push(list[k].failCount)
        }
        if (this.isEcharts) {
          this.$nextTick(() => {
            this.initEcharts()
          })
        } else {
          this.$nextTick(() => {
            this.getEcharts()
          })
        }
      })
    },
    //首页信息
    getUserInfo () {
      apis.index.useIndex().then(res => {
        this.userList = res.data.user
        this.customerList = res.data.kefu
        this.getArticleList()
        this.getSuccessRate()
      })
    },
    //公告列表
    getArticleList () {
      apis.index.articleList().then(res => {
        this.noticeList = res.data.article.splice(0, 6)
        this.openApi = res.data.open_api.splice(0, 6)
      })
    },
    //截取公告时间
    interceptTime (time) {
      var result = time.split("-");
      return result[1] + '/' + result[2]
    },
    //跳转费用明细
    Viewdetails () {
      this.$router.replace('/detailed')
    },
    //跳转充值
    ViewRecharge () {
      this.page = 'recharge'
    },
    //切换echarts
    tabEcharts () {
      this.isEcharts = !this.isEcharts;
      if (this.isEcharts) {
        this.$nextTick(() => {
          this.initEcharts()
        })

      } else {
        this.$nextTick(() => {
          this.getEcharts()
        })

      }

    },
    //初始化折线图echarts
    initEcharts () {

      let myRefDom = this.$refs.myRef;
      //初始化dom节点
      /* // eslint-disable-next-line no-undef */
      let myChart = echarts.init(myRefDom);
      var option;

      option = {
        xAxis: {
          type: 'category',
          data: this.xData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>{a0}:{c0}%,<br/>{a1}:{c1}%'
        },
        /* legend: {
          data: ['失败率', '成功率']
        }, */
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          top: '1.5%',
          containLabel: true
        },
        series: [
          {
            name: '失败率',
            data: this.failData,
            type: 'line',
            itemStyle: {
              normal: {
                color: "#FF3D54",//折线点的颜色
                lineStyle: {
                  color: '#FF3D54'
                }
              }
            }
          },
          {
            name: '成功率',
            data: this.SuccessData,
            type: 'line',
            itemStyle: {
              normal: {
                color: "#2FC25B",
                lineStyle: {
                  color: '#2FC25B'
                }
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
    },
    //初始化柱状图
    getEcharts () {

      let myEchartsDom = this.$refs.myEcharts;
      //初始化dom节点
      /* // eslint-disable-next-line no-undef */
      let myechart = echarts.init(myEchartsDom);
      var option2;

      option2 = {
        xAxis: {
          type: 'category',
          data: this.xData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>{a0}:{c0}%,<br/>{a1}:{c1}%'
        },
        series: [
          {
            name: '失败率',
            data: this.failData,
            type: 'bar',
            itemStyle: {
              normal: {
                color: "#FF3D54",//折线点的颜色
                lineStyle: {
                  color: '#FF3D54'
                }
              }
            }
          },
          {
            name: '成功率',
            data: this.SuccessData,
            type: 'bar',
            itemStyle: {
              normal: {
                color: "#2FC25B",
                lineStyle: {
                  color: '#2FC25B'
                }
              }
            }
          }
        ],
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          top: '1.5%',
          containLabel: true
        },
      };

      option2 && myechart.setOption(option2);

    },
    getPaymentMsg (res) {
      this.page = res[0]
    }
  },
  watch: {
    '$route.params.page' () {
      this.getUserInfo()
    },


  }
};
</script>
<style scoped lang="scss">
::v-deep .el-col {
  margin: 0 0 16px 0;
}
::v-deep .el-row {
  margin: 0;
}

.content {
  font-family: PingFangSC-Regular, PingFang SC;
  .bread {
    margin-bottom: 20px;
  }
  .box-card {
    height: 240px;
    background: #ffffff;
    border-radius: 2px;
    .clearfix {
      display: flex;
      align-items: center;
      .h_left {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        margin-right: 15px;
      }
      .h_right {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .item {
      margin-bottom: 18px;
      /* padding: 12px; */
      display: flex;

      /*  justify-content: space-between; */
      align-items: center;
      .item_left {
        margin-left: 20px;
        margin-right: 200px;
        .item_title {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
        .item_balance {
          margin: 15px 0 15px 0;
          font-size: 32px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
    .line {
      margin-top: 15px;
      margin-right: 50px;
      width: 1px;
      height: 120px;
      background: #e9e9e9;
    }
    .item_right {
      display: flex;
      justify-content: center;
      align-items: center;
      .i_r_code {
        padding: 10px;
        img {
          width: 82px;
          height: 83px;
        }
        width: 100px;
        height: 120px;
        background: #f6f8ff;
        border-radius: 3px;
        text-align: center;
        margin-right: 15px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 14px;
      }
      .i_r_text {
        .p_title {
          width: 264px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
        .p_phone,
        .p_wchat {
          font-size: 14px;

          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
        .p_phone {
          margin: 15px 0;
        }
      }
    }
  }
  .banner {
    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
      background-color: #d3dce6;
    }
    img {
      width: 100%;
      height: 240px;
    }
  }

  .bottom_card {
    ::v-deep .el-card__body {
      padding: 20px;
    }
    padding: 0;
    height: 548px;
    background: #ffffff;
    border-radius: 2px;
    .clearfix {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .h_left {
        margin-right: 180px;
        .h_black {
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
          font-size: 16px;
          margin-right: 10px;
        }
        .h_gray {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    .echartsTop {
      display: flex;
      justify-content: space-between;
      margin-right: 2%;
      .echartTitle {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        margin-left: 2%;
        div {
          margin-right: 10px;
          .sucsses {
            display: inline-block;
            margin-bottom: 3px;
            width: 12px;
            height: 2px;
            background: #2fc25b;
            margin-right: 10px;
          }
          .fail {
            margin-right: 10px;
            display: inline-block;
            margin-bottom: 3px;
            width: 12px;
            height: 2px;
            background: #ff3d54;
          }
        }
      }
      .echartsRight {
        .icon {
          cursor: pointer;
          width: 32px;
          height: 16px;
          background: #e8e8e8;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
        }
      }
    }
  }
  .b_right_card {
    height: 266px;
    margin-bottom: 16px;
    .clearfix {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
    .Notice {
      .Noticeli {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        display: inline;
        .time {
          display: inline;
          font-size: 14px;
          margin-right: 10px;
          color: #8c8c8c;
        }
        .bi {
          margin-right: 10px;
          display: inline-block;
          width: 44px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #ff4d4f;
        }
        .red {
          color: #ff4d4f;
        }
      }
    }
  }
}
/* .clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
} */
</style>
